import { WORKFLOW_FIELDS } from '../fragments'

export default `
  ${WORKFLOW_FIELDS}
  mutation updateWorkflow($projectId: String!, $input: UpdateWorkflowInput!) {
    updateWorkflow(projectId: $projectId, input: $input) {
      ...WorkflowFields
    }
  }
`
